var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.946,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#fff}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    style: {
      opacity: 0.996
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    className: "cls-2",
    width: 16,
    height: 12.952,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    className: "cls-2",
    transform: "rotate(45 -8.596 14.87)",
    d: "M0 0h3.191v3.191H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageOn);
export default __webpack_public_path__ + "static/media/messageON.0498e4f5c001813ed11f4431e5e9b90e.svg";
export { ForwardRef as ReactComponent };